export default __webpack_public_path__ + "static/media/cancel.4bbd0c7d.svg";